import { getDayOfMonth, getFirstDate, getLastDate } from '../../const';
import { VIEW_MODE } from '../../const';
import styles from '../../Leaderboard.module.scss';

type ICashCollectionTitle = {
  showDropdown: boolean;
  view: VIEW_MODE;
};

const CashCollectionTitle = (props: ICashCollectionTitle) => {
  const { showDropdown, view } = props;

  return (
    <div>
      {!showDropdown ? (
        <span className={styles.titleWithDropdown}>
          {view === VIEW_MODE.CURRENT ? (
            <span className={styles.darkGray}>Last {getDayOfMonth()} day(s) cash collected</span>
          ) : (
            <span className={styles.darkGray}>Cash collected last month</span>
          )}
          <b>
            {' '}
            {getFirstDate()} - {getLastDate(view)}
          </b>
        </span>
      ) : (
        <span className={styles.titleWithDropdown}>Cash Collection Breakup</span>
      )}
    </div>
  );
};

export default CashCollectionTitle;
